import {Controller} from '@hotwired/stimulus';
import $ from "jquery";

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static targets = [
        'documentContainerInfoAndActions',
        'documentContainerCreateOrUpload',
        'feeDocumentEdit',
        'bookingDocumentHtml',
        'feeDocumentInput',
        'feeDocumentFileName',
    ];

    containerController = null;

    showDocumentInputs(event) {
        event.preventDefault();

        this.documentInputsContainerTarget.style.removeProperty('display');

        event.target.setAttribute('data-action', 'document--create-or-upload#showDocumentTemplate');
    }

    showDocumentTemplate(event) {
        event.preventDefault();

        if (this.containerController.descriptionInputTarget && this.containerController.descriptionInputTarget.value) {
            this.containerController.descriptionInputTarget.classList.remove('is-invalid');
        } else {
            this.containerController.descriptionInputTarget.classList.add('is-invalid');
        }

        if (this.containerController.amountInputTarget.value) {
            this.containerController.amountInputTarget.classList.remove('is-invalid');
        } else {
            this.containerController.amountInputTarget.classList.add('is-invalid');
        }

        showPreloader();

        const data = this.containerController.getDataForCreateDocumentModal();

        $.ajax({
            url: routes['app_document_feedocumentcreate'],
            type: 'POST',
            data: data,
            success: (response) => {
                if (response.status) {
                    this.containerController.hide();

                    this.containerController.documentCreateModalOutlet.open(response.template);
                } else {
                    hidePreloader();
                    addAlert('danger', response.message);
                }
            },
            error: () => {
                addAlert('danger', translations['profile.An unknown error occurred.']);
                hidePreloader();
            }
        }).done(() => {
            hidePreloader();
        });
    }

    documentEdit() {
        this.containerController.hide();

        this.containerController.documentCreateModalOutlet.open($(this.bookingDocumentHtmlTarget).val());
    }

    documentRemove() {
        $(this.documentContainerInfoAndActionsTarget).css('display', 'none')
        $(this.documentContainerCreateOrUploadTarget).css('display', 'block')
        $(this.bookingDocumentHtmlTarget).text('').val(null);
        $(this.feeDocumentFileNameTarget).text('');
        $(this.bookingDocumentHtmlTarget).val(null);

        addAlert('success', translations['payment_popup.Document deleted successfully']);
    }

    documentUpload(event) {
        $(this.documentContainerInfoAndActionsTarget).css('display', 'flex');
        $(this.documentContainerCreateOrUploadTarget).css('display', 'none');
        $(this.feeDocumentEditTarget).css('display', 'none');
        $(this.feeDocumentFileNameTarget).text(event.target.files[0].name);

        addAlert('success', translations['payment_popup.Document added successfully']);
    }

    getData() {
        let data = {};

        if ($(this.feeDocumentInputTarget).prop('files')[0]) {
            data.fee_document = $(this.feeDocumentInputTarget).prop('files')[0];
        }

        if (this.bookingDocumentHtmlTarget.value) {
            data.document_html = this.bookingDocumentHtmlTarget.value;
        }

        return data;
    }
}
